import styled from 'styled-components'
import backgroundBanner from 'assets/images/background-verde.png'
import backgroundFaq from 'assets/images/background-verde.png'
import personaFaq from 'assets/images/personaFaq.png'

export const BannerWrapper = styled.section`
  align-items: center;
  background-color: #f9f9f9;
  display: flex;
  gap: 1.5rem;
  min-height: 600px;
  justify-content: center;
  align-items: flex-end;
  width: 100%;

  & .container-banner {
    display: flex;
    justify-content: center;
  }

  & .gap-40 {
    gap: 4rem;
  }

  & h2 {
    color: #4c4c4c;
    font-size: 3rem;
    font-weight: 800;
    line-height: 3.65rem;
    text-align: left;
    white-space: nowrap;
  }

  & .tag-Laranja {
    color: #ff6500;
  }

  & .subtitle {
    color: #4c4c4c;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.8rem;
    text-align: left;
    margin-top: 20px;
  }

  & .input-cpf {
    border: 1px solid white;
    width: 300px;
    border-radius: 50px;
    height: 56px;
    text-align: center;
    &.mobile-border {
      border-color: transparent;
    }
  }

  & .simulation-button {
    width: 300px;
    height: 56px;
    transition: all 0.3s ease;
  }

  & .tips {
    color: #4c4c4c;
    font-size: 16px;
    line-height: 1rem;
    display: flex;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  & .tips-text {
    display: inline-block;
  }

  @media screen and (max-width: 1199px) {
    background-color: var(--branco);
    min-height: 450px;
    padding: 0 10px;
    & .input-cpf {
      height: 48px;
      max-width: 100%;
    }
  }

  @media screen and (max-width: 991px) {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    background-color: lightgray;
    min-height: 500px;
    padding: 30px 15px;

    & .container-banner {
      flex-direction: column;
      width: 100%;
    }

    & h2 {
      font-size: 2.5rem;
      line-height: 2.8rem;
      white-space: normal;
      text-align: center;
    }

    & .subtitle {
      font-size: 1.5rem;
      line-height: 1.6rem;
      margin-top: 20px;
    }

    & .input-cpf {
      height: 48px;
      max-width: 100%;
    }

    & .simulation-button {
      max-width: 100%;
      height: 48px;
    }

    & .gap-40 {
      gap: 2rem !important;
      width: 100%;
    }

    & .tips {
      flex-wrap: wrap;
      justify-content: center;
      gap: 10px !important;
      font-size: 0.9rem;

      img {
        width: 25px !important;
      }
    }
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: left;
    justify-content: left;
    background-color: #f9f9f9;
    min-height: auto;
    padding: 40px 20px;

    & .container-banner {
      flex-direction: column;
      align-items: left;
      width: 100%;
    }

    & h2 {
      text-align: left;
      white-space: normal;
    }

    & h2 .tag-Laranja {
      display: inline;
    }

    & h2 br {
      display: none;
    }

    & .gap-40 {
      gap: 2rem;
      flex-direction: column;
    }

    & .subtitle {
      font-size: 1.2rem;
      line-height: 1.4rem;
      margin-top: 20px;
      align-items: left;
    }

    & .input-cpf {
      height: 48px;
      max-width: 100%;
    }

    & .simulation-button {
      width: 100% !important;
      max-width: 100%;
      height: 48px;
    }

    & .tips {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      text-align: center;
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 480px) {
    padding: 30px 15px;
    background-color: #f9f9f9;
    & h2 {
      font-size: 1.8rem;
      line-height: 2rem;
      align-items: left;
      justify-content: left;
      text-align: left;
    }

    & .subtitle {
      font-size: 1rem;
      line-height: 1.2rem;
      margin-top: 15px;
    }

    & .input-cpf {
      height: 44px;
    }

    & .simulation-button {
      height: 44px;
      font-size: 1.2rem !important;
    }
    & .tips {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      text-align: center;
      font-size: 1rem;
    }
  }
`

export const CardSimulacao = styled.div`
  align-items: center;
  background: var(--branco);
  border-radius: 30px;
  box-shadow: 0px 0px 5.41032px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  height: fit-content;
  max-width: 600px;
  padding: 20px;
  row-gap: 15px;
  width: 100%;

  & .titulos {
    align-items: center;
    display: flex;
    flex-direction: column;

    & label {
      color: var(--verde-riber);
      font-weight: 700;
      font-size: 28px;
      line-height: 40px;
    }

    & span {
      color: var(--preto-riber);
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
    }
  }
`

export const InfoProdutosWrapper = styled.section`
  background-color: var(--branco);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  padding: 40px 40px;

  & .title {
    color: #4c4c4c;
    font-size: 3rem;
    font-weight: 800;
    text-align: center;
    width: 100%;
  }
  & .title-tag-Laranja {
    font-size: 3rem;
    font-weight: 800;
    text-align: center;
    width: 100%;
    color: #ff6500;
    flex-wrap: nowrap;
  }

  & .subtitle {
    color: #4c4c4c;
    display: flex;
    font-size: 1.6rem;
    font-weight: 400;
    text-align: center !important;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  & .content-produtos {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    max-width: 1320px;
    width: 100%;
    gap: 20px;
  }

  @media screen and (max-width: 991px) {
    & .title {
      font-size: 2rem;
      text-align: start;
    }

    & .subtitle {
      font-size: 1.4rem;
      text-align: start;
    }

    & .content-produtos {
      gap: 20px;
      flex-direction: row;
      padding: 0 20px;
    }
    & .title-tag-Laranja {
      font-size: 2rem;
      font-weight: 800;
      text-align: left;
      width: 100%;
      color: #ff6500;
      flex-wrap: nowrap;
    }
  }

  @media screen and (max-width: 768px) {
    & .title {
      font-size: 1.8rem;
    }

    & .subtitle {
      font-size: 1.2rem;
    }
    & .title-tag-Laranja {
      font-size: 1.8rem;
      font-weight: 800;
      text-align: left;
      width: 100%;
      color: #ff6500;
      flex-wrap: nowrap;
    }
    & .content-produtos {
      align-items: center;
      flex-direction: column;
      padding: 0 20px;
      justify-content: flex-start;
    }
  }
  @media screen and (max-width: 480px) {
    padding: 30px 20px;
    gap: 2rem;

    & .title {
      font-size: 1.6rem;
      text-align: center;
    }

    & .title-tag-Laranja {
      font-size: 1.6rem;
      text-align: center;
      flex-wrap: wrap;
    }

    & .subtitle {
      font-size: 1rem;
      text-align: center;
      flex-direction: column;
      align-items: center;
    }

    & .content-produtos {
      gap: 15px;
      padding: 0 10px;
    }
  }
`

export const CardInfoProduto = styled.div`
  border-radius: 26px;
  border: 1px solid #c6c6c6;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 17.8125rem;
  min-height: 24.0625rem;
  padding: 10px;
  /* width: 280px; */
  gap: 20px;

  & .content-infos {
    display: flex;
    flex-direction: column;
    row-gap: 20px;

    & .icon {
      color: var(--roxo-riber);
      font-weight: 300;
      margin-bottom: 20px;
    }

    & label {
      color: #4c4c4c;
      font-weight: 800;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      text-transform: uppercase;
      width: 100%;
    }

    & span {
      color: var(--verde-riber);
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      margin-top: 10px;
    }

    & ul {
      display: flex;
      flex-direction: column;
      row-gap: 0.5rem;
      padding-left: 15px;
      margin-top: 20px;

      & li {
        color: #4c4c4c;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        margin: 0;
        padding: 0;

        &::marker {
          font-size: 16px;
        }
      }
    }
  }
  & .button-simulation {
    width: 146px;
    height: 40px;
    background-color: var(--verde-riber);
    font-size: 1rem;
    border-radius: 50px;
    margin-bottom: 15px;
  }

  & a {
    align-items: center;
    color: var(--roxo-riber);
    column-gap: 10px;
    display: flex;
    font-weight: 700;
    font-size: 14px;
    justify-content: center;
    line-height: 20px;
    text-align: center;
    text-decoration: none;
    width: 100%;
  }

  @media screen and (max-width: 991px) {
    min-height: 24rem;
  }

  @media screen and (max-width: 768px) {
    min-height: 22rem;
  }
`

export const AtencaoWrapper = styled.div`
  background: #737373;
  display: flex;
  padding: 20px;

  & div {
    align-items: center;
    color: var(--branco);
    display: flex;
    font-weight: 600;
    font-size: 1.2rem;
    gap: 2rem;
    justify-content: center;
    line-height: 1.7rem;
    width: 100%;

    & .icon {
      color: var(--verde-riber);
    }
  }

  @media screen and (max-width: 991px) {
    padding: 15px;

    & div {
      font-size: 1.4rem;
      gap: 1.5rem;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 10px;

    & div {
      font-size: 1.2rem;
      line-height: 1.4rem;
      gap: 1rem;
    }
  }
`

export const ApresentacaoEmprestimoWrapper = styled.aside`
  align-items: center;
  display: flex;
  flex-direction: column;
  row-gap: 150px;

  & label {
    color: var(--roxo-riber);
    font-weight: 700;
    font-size: 28px;
    line-height: 32px;

    & span {
      color: var(--verde-riber);
    }
  }

  & p {
    color: var(--preto-riber);
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
  }

  .primeira-linha,
  .segunda-linha {
    align-items: center;
    display: flex;
    gap: 100px;
    max-width: 800px;
  }

  .primeira-linha {
    text-align: right;
  }

  .segunda-linha {
    text-align: left;
  }

  @media screen and (max-width: 991px) {
    .primeira-linha,
    .segunda-linha {
      flex-direction: column;
      padding: 0 20px;
      text-align: center;
    }
  }
`

export const VantagensWrapper = styled.aside`
  align-items: center;
  background: url(${backgroundBanner}), var(--verdeGradiente-riber);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100%;
  display: flex;
  justify-content: space-around;
  padding: 100px 40px;

  & label {
    color: var(--branco);
    font-weight: 700;
    font-size: 40px;
    line-height: 54px;
    margin-bottom: 20px;
    text-align: center;

    & span {
      color: var(--roxo-riber);
    }
  }

  & ul {
    display: flex;
    flex-direction: column;
    row-gap: 30px;
    max-width: 600px;

    & li {
      align-items: start;
      color: var(--branco);
      column-gap: 15px;
      display: flex;
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
      list-style: none;

      span {
        display: flex;
        flex-direction: column;
        label {
          font-weight: 700;
          font-size: 30px;
          text-align: start;
        }
      }
    }
  }

  @media screen and (max-width: 991px) {
    flex-direction: column-reverse;
  }
`
export const ImageFraude = styled.img`
  width: 650px;
  height: auto;
  margin: 0 auto;
  justify-content: center;
  display: flex;
  align-items: center;
`

export const EfetuacaoEmprestimoWrapper = styled.article`
  display: flex;

  & div {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    width: 50%;

    & img {
      max-width: 500px;
      width: 100%;
    }

    & label {
      color: var(--roxo-riber);
      font-weight: 700;
      font-size: 40px;
      line-height: 54px;
      width: 100%;

      & span {
        color: var(--verde-riber);
      }
    }

    & ul {
      padding-left: 0;
      & li {
        column-gap: 15px;
        display: flex;
        flex-direction: column;
        list-style: none;

        & .number {
          align-items: center;
          background: var(--verde-riber);
          border-radius: 5px;
          color: var(--branco);
          display: flex;
          height: 35px;
          justify-content: center;
          width: 35px;
        }

        & label {
          color: var(--verde-riber);
          display: flex;
          font-weight: 700;
          font-size: 18px;
          gap: 15px;
          line-height: 28px;
        }

        & span {
          color: var(--preto-riber);
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
          padding-left: 50px;
        }
      }
    }
  }

  @media screen and (max-width: 991px) {
    align-items: center;
    flex-direction: column;

    & div {
      width: 100%;
    }
  }
`
export const FaqWrapper = styled.aside`
  background: url(${backgroundFaq}) no-repeat center;
  background-size: cover;
  display: flex;
  justify-content: space-around;
  padding: 80px;
  min-height: 650px;

  .img-faq {
    width: 500px;
    object-fit: contain;
  }

  & .faq {
    display: flex;
    flex-direction: column;
    gap: 40px;
    max-width: 600px;

    & div {
      flex-direction: column;
      gap: 40px;
    }

    & h3 {
      color: var(--branco);
      font-weight: 700;
      font-size: 27px;
      text-align: center;
    }
  }

  @media screen and (max-width: 1200px) {
    .img-faq {
      width: 400px;
    }
  }

  @media screen and (max-width: 991px) {
    background-image: url(${personaFaq}), url(${backgroundFaq});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 600px, cover;
    justify-content: center;
  }

  @media screen and (max-width: 768px) {
    background-size: 400px, cover;
  }
`

export const CardFaq = styled.div`
  background: var(--light-gray);
  border-radius: 20px;
  display: flex;
  padding: 10px 20px;
  width: 100%;

  & label {
    align-items: center;
    color: var(--preto-riber);
    display: flex;
    font-weight: 400;
    font-size: 18px;
    gap: 10px;
    justify-content: space-between;
    line-height: 32px;

    & .icon {
      min-width: 40px;
    }
  }

  & p {
    color: var(--preto-riber);
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
`

export const RiberPertoWrapper = styled.div`
  & .title {
    font-weight: 800;
    font-size: 3rem;
    width: 100%;
    color: #4c4c4c;
  }

  & .subtitle {
    color: var(--verde-riber);
    font-weight: 700;
    font-size: 1.7rem;
  }

  & p {
    font-size: 1.2rem;
  }

  & .selects-content {
    max-width: 350px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  @media screen and (max-width: 991px) {
    & .title {
      font-size: 2rem;
    }

    & .subtitle {
      font-size: 1.4rem;
    }

    & p {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 768px) {
    & .title {
      font-size: 1.8rem;
    }

    & .subtitle {
      font-size: 1.2rem;
    }

    & p {
      font-size: 1rem;
    }
  }
`

export const LocsWrapper = styled.div`
  display: flex;
  gap: 10px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 26px;

  & .icon {
    color: var(--verde-riber);
  }
`

export const CredibilidadeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: #e9e8e9;
  padding: 80px 40px;

  & .title {
    font-weight: 800;
    font-size: 3rem;
    text-align: center;
    color: #4c4c4c;
  }

  & .description {
    font-weight: 400;
    font-size: 1.7rem;
    text-align: center;
    color: #4c4c4c;
  }
  & .simulation-button {
    width: 300px;
    height: 56px;
    transition: all 0.3s ease;
    padding: 0 150px;
  }

  & .parceiros {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    margin-top: 50px;

    & h5 {
      font-weight: 700;
      font-size: 1.5rem;
      color: #4c4c4c;
      text-align: center;
    }
  }

  @media screen and (max-width: 991px) {
    & .title {
      font-size: 2rem;
      text-align: start;
    }

    & .description {
      font-size: 1.4rem;
      line-height: 1.4rem;
      text-align: start;
    }

    & .parceiros h5 {
      font-size: 1.3rem;
    }

    & .simulation-button {
      padding: 0 100px;
    }
  }

  @media screen and (max-width: 768px) {
    & .title {
      font-size: 1.8rem;
    }

    & .description {
      font-size: 1.2rem;
    }

    & .parceiros h5 {
      font-size: 1.1rem;
    }

    & .simulation-button {
      padding: 0 50px;
    }
  }
`

export const ComparativoWrapper = styled.div`
  display: flex;
  background: var(--branco);
  padding: 50px 0px;

  .container-comparativo {
    margin-bottom: 250px;
  }

  & h2 {
    font-size: 3rem;
    font-weight: 800;
    color: #4c4c4c;
    margin-bottom: 1.5rem;
    line-height: 1.2;
  }

  & p {
    font-size: 1.7rem;
    margin-top: 2.5rem;
    margin-bottom: 20px;
    color: #4c4c4c;
    line-height: 1.3;
  }

  & .simulation-button {
    width: 300px;
    height: 56px;
    transition: all 0.3s ease;
  }

  @media screen and (max-width: 1199px) {
    padding: 40px 0px;

    .container-comparativo {
      margin-bottom: 200px;
    }
  }

  @media screen and (max-width: 991px) {
    padding: 30px 0px;

    & h2 {
      font-size: 2rem;
      margin-bottom: 1rem;
      line-height: 1.25;
    }

    & p {
      font-size: 1.4rem;
      margin-top: 1.5rem;
      margin-bottom: 15px;
      line-height: 1.35;
    }

    .container-comparativo {
      margin-bottom: 10px;
    }

    & .simulation-button {
      width: 100% !important;
      max-width: 100%;
      height: 48px;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 25px 0px;

    & h2 {
      font-size: 1.8rem;
      margin-bottom: 0.8rem;
      line-height: 1.3;
    }

    & p {
      font-size: 1.2rem;
      margin-top: 1rem;
      margin-bottom: 12px;
      line-height: 1.4;
    }

    .container-comparativo {
      margin-bottom: 10px !important;
    }

    & .simulation-button {
      width: 100% !important;
      max-width: 100%;
      height: 48px;
    }
  }

  @media screen and (max-width: 480px) {
    padding: 20px 15px;

    & h2 {
      font-size: 1.6rem;
      margin-bottom: 0.5rem;
      line-height: 1.35;
    }

    & p {
      font-size: 1rem;
      margin-top: 0.8rem;
      margin-bottom: 10px;
      line-height: 1.45;
    }

    .container-comparativo {
      margin-bottom: 10px !important;
    }

    & .simulation-button {
      max-width: 100%;
      margin-top: 5px;
      padding: 10px 15px;
      font-size: 0.9rem;
    }
  }
`

export const ChartWrapper = styled.div`
  background-color: #a1c7ad;
  padding: 2rem;
  box-shadow: 0px 0px 5.41032px rgba(0, 0, 0, 0.18);
  border-radius: 20px;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  height: 550px;
  flex-direction: row;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    align-items: start;
    justify-content: start;
    height: auto;
    padding: 1.5rem;
  }

  @media screen and (max-width: 768px) {
    padding: 1rem;
  }
`

export const Bar = styled.div<{ height: string; color: string }>`
  width: 60px;
  height: ${({ height }) => height};
  background-color: ${({ color }) => color};
  border-radius: 12px 12px 0 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 0.9rem;

  @media screen and (max-width: 991px) {
    width: ${({ height }) => height};
    height: 50px;
    border-radius: 12px;
    font-size: 0.8rem;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }

  @media screen and (max-width: 768px) {
    width: ${({ height }) => `calc(${height} * 0.7)`};
    height: 30px;
    font-size: 0.6rem;
  }
`

export const Label = styled.div`
  color: var(--roxo-riber);
  margin-top: 0.5rem;
  font-size: 0.85rem;
  text-align: center;
  font-weight: 600;
  text-wrap: break-word;

  @media screen and (max-width: 991px) {
    margin-top: 0;
    margin-left: 0.5rem;
    font-size: 0.8rem;
    text-align: left;
  }

  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
    font-weight: 700;
  }
`

export const BarGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 991px) {
    align-items: start;
    margin-bottom: 1rem;
  }
`

export const PassoAPassoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 80px 40px;
  gap: 40px;

  & .title {
    color: #4c4c4c;
    font-size: 3rem;
    font-weight: 800;
  }

  & .subtitle {
    color: #4c4c4c;
    font-size: 1.7rem;
    line-height: 1.7rem;
  }
  & .stepper-small {
    max-width: 800px;
    width: 100%;
    align-items: center;
  }
  & .button-simulation {
    width: 300px;
    height: 56px;
    background-color: var(--verde-riber);
    font-size: 1.5rem;
    border-radius: 50px;
    max-width: 350px;
  }

  & .card-passo {
    background: var(--branco);
    border-radius: 40px;
    box-shadow: 0px 0px 5.41032px rgba(0, 0, 0, 0.18);
    display: flex;
    flex-direction: column;
    padding: 30px 20px;
    width: 100%;
    max-width: 400px;

    & label {
      color: #4c4c4c;
      font-weight: 800;
      font-size: 2rem;
      line-height: 2rem;
      margin-bottom: 1.625rem;
    }

    & p {
      color: #4c4c4c;
      font-weight: 500;
      font-size: 1rem;
      line-height: 1.2rem;
    }
  }

  @media screen and (max-width: 991px) {
    & .title {
      font-size: 2rem;
    }

    & .subtitle {
      font-size: 1.4rem;
    }

    & .card-passo {
      & label {
        font-size: 1.8rem;
        line-height: 1.8rem;
      }

      & p {
        font-size: 1.2rem;
        line-height: 1.1rem;
      }
    }
  }

  @media screen and (max-width: 768px) {
    & .title {
      font-size: 1.8rem;
    }

    & .subtitle {
      font-size: 1.2rem;
    }

    & .card-passo {
      & label {
        font-size: 1.6rem;
      }

      & p {
        font-size: 1rem;
        line-height: 1rem;
      }
    }
    & .button-simulation {
      width: 100% !important;
      max-width: 100%;
      height: 48px;
    }
  }
`

export const StepperContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 40px 0;
`

export const Line = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2px;
  background-color: var(--verde-riber);
  z-index: 1;
  transform: translateY(-50%);
`

export const Step = styled.div`
  background-color: var(--verde-riber);
  color: black;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`
